import React from 'react';

function ConfirmModal({confirmAction, closeAction, isSubmitting}) {
  return (
    <div id="popup-modal" tabindex="-1" class="mx-auto w-full fixed inset-0 flex items-center justify-center overflow-auto">
      <div class="relative w-full max-w-md max-h-full">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <button 
            onClick={closeAction} 
            disabled={isSubmitting}
            type="button" 
            class={`absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
            data-modal-hide="popup-modal"
          >
            <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
            </svg>
            <span class="sr-only">Close modal</span>
          </button>
          <div class="p-6 text-center">
            <svg class="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
            </svg>
            <h3 class="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">Êtes-vous certain de vouloir valider ce questionnaire ?</h3>
            <button 
              onClick={confirmAction} 
              disabled={isSubmitting}
              data-modal-hide="popup-modal" 
              type="button" 
              class={`text-white bg-green-600 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-green-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              {isSubmitting ? (
                <>
                  <div class="animate-spin rounded-full border-t-2 border-b-2 border-white h-4 w-4 mr-2"></div>
                  Enregistrement...
                </>
              ) : (
                'Oui, je valide'
              )}
            </button>
            <button 
              onClick={closeAction} 
              disabled={isSubmitting}
              data-modal-hide="popup-modal" 
              type="button" 
              class={`text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              Non, retour
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;